<div  class="agpr-mentionCustomization">
    @if (field.label) {
        <div class="agpr-formField-heading agpr-mentionCustomizationLabel">
            <label class="agpr-formField-headingLabel">{{ field.label | localize }}</label>
            <div class="agpr-formField-headingButtons">
                @if(field.allowExpertMode) {
                    <agpr-button
                        class="agpr-formField-headingButton"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-code"
                        tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                        tooltipPosition="top"
                        (click)="saveExpertTemplate()"
                    ></agpr-button>
                }
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-floppy-disk"
                    tooltip="PageBuilder.formField.tooltip.saveStyle"
                    tooltipPosition="top"
                    (click)="saveMentionStyle()"
                ></agpr-button>
            </div>
        </div>
    }

    <div class="agpr-mentionCustomization-content">
        <div class="agpr-mentionCustomization-styleState">
            <div class="agpr-inputGroupRow">
                <div class="agpr-inputGroupRow-dropdown">
                    <agpr-dropdown-field
                        [id]="id + '_styleStateDropdown'"
                        [value]="value.displayStyleState"
                        [field]="styleStateField"
                        [updateOptions]="styleStateField.options"
                        [labelClass]="'agpr-dropdown-label--semibold'"
                        (changes)="setStyle($event, styleStateField.property)"
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-inputGroupRow-buttons">
                    <agpr-button
                        [id]="id + '_manageStyles'"
                        [style]="buttonTypes.block"
                        icon="fa-regular fa-duotone fa-gear"
                        tooltip="PageBuilder.formField.tooltip.manageStyles"
                        tooltipPosition="top"
                        (click)="manageStylesButtonClicked()"
                    ></agpr-button>
                </div>
            </div>
        </div>

        @if (!value.template || internalUser) {
            <agpr-color-picker-field
                class="agpr-mentionCustomizationField-backgroundColorPicker"
                [id]="id + '_backgroundColorPicker'"
                [value]="value.backgroundColor"
                [field]="backgroundColorField"
                [doBorder]="true"
                tooltip="PageBuilder.formField.tooltip.backgroundColor"
                (changes)="setStyle($event, backgroundColorField.property)"
            ></agpr-color-picker-field>

            @if (showCardHeight) {
                <div class="agpr-formField-heading agpr-mentionCustomization-cardHeight">
                    <label class="agpr-formField-headingLabelSmall">{{ 'Mention.customization.cardHeight' | localize }}</label>
                </div>
                <div
                    role="radiogroup"
                    [attr.aria-label]="'Mention.customization.cardHeight' | localize"
                >
                    <agpr-radio
                        class="agpr-mentionCustomization-cardHeightFixed"
                        [id]="id + '_includeFixed'"
                        label="Mention.customization.fixed"
                        hiddenLabel="Mention.customization.fixed"
                        [value]="mentionCardHeightEnum.fixed"
                        name="cardHeight"
                        [(ngModel)]="selectedMentionCardHeightRadioButton"
                        (ngModelChange)="mentionCardHeightChange($event)"
                    ></agpr-radio>
                    <agpr-radio
                        class="agpr-mentionCustomization-cardHeightFlexible"
                        [id]="id + '.includeFlexible'"
                        label="Mention.customization.flexible"
                        hiddenLabel="Mention.customization.flexible"
                        [value]="mentionCardHeightEnum.flexible"
                        name="cardHeight"
                        [(ngModel)]="selectedMentionCardHeightRadioButton"
                        (ngModelChange)="mentionCardHeightChange($event)"
                    ></agpr-radio>
                </div>
            }

            <div class="agpr-formField-heading agpr-mentionCustomization-sectionLabel">
                <label class="agpr-formField-headingLabelSmall">{{ sectionHeadingField.label | localize }}</label>
            </div>
            <div class="agpr-mentionCustomization-showSectionHeading">
                <agpr-checkbox
                    class="agpr-mentionCustomization-showSectionHeadingCheckbox"
                    [id]="id + '_showSectionHeading'"
                    label="Mention.customization.showSectionHeading"
                    [binary]="true"
                    [bottomMargin]="showSectionHeading"
                    [(ngModel)]="showSectionHeading"
                    (ngModelChange)="showSectionHeadingChange()"
                ></agpr-checkbox>
            </div>
            @if (showSectionHeading) {
                <agpr-briefing-text-style-field
                    [layoutVariant]="'sectionHeading'"
                    [id]="id + '_sectionHeading'"
                    [field]="sectionHeadingField"
                    [showLabel]="false"
                    [value]="sectionHeading"
                    [hidePadding]="true"
                    (changes)="setStyle($event, sectionHeadingField.property)"
                ></agpr-briefing-text-style-field>
            }

            <div
                class="agpr-mentionCustomization-toggleAll"
                [class.agpr-mentionCustomization-toggleAll--tight]="showSectionHeading"
            >
                <agpr-button
                    class="agpr-mentionCustomization-toggleAllButton"
                    [style]="buttonTypes.textToggle"
                    [label]="toggleAllLabel"
                    (click)="toggleAllSections()"
                ></agpr-button>
            </div>

            <div class="agpr-mentionCustomization-panels">
                @if (showHeadlinesSection) {
                    <agpr-panel
                        [id]="id + '_headlinesPanel'"
                        [header]="'Briefing.textStyle.heading.label'"
                        [headerIcon]="'fa-regular fa-duotone fa-heading'"
                        [styleClass]="'agpr-mentionCustomization-panel agpr-mentionCustomization-panelBase agpr-mentionCustomization-panel--headlines'"
                        [marginTop]="0"
                        [noBorder]="true"
                        [contentPadding]="false"
                        [paddingBottom]="0"
                        [(collapsed)]="sectionCollapsed.headlines"
                    >
                        <div class="agpr-mentionCustomization-panelContent">
                            <agpr-briefing-text-style-field
                                [layoutVariant]="'headlines'"
                                [id]="id + '_heading'"
                                [field]="headingField"
                                [value]="heading"
                                [smallLabel]="true"
                                [showLabel]="false"
                                [hidePadding]="true"
                                (changes)="setStyle($event, headingField.property)"
                            ></agpr-briefing-text-style-field>
                            <agpr-checkbox
                                class="agpr-mentionCustomization-underlineLinksCheckbox"
                                [id]="id + '_underlineLinks'"
                                label="Mention.customization.underlineLinks"
                                [binary]="true"
                                [(ngModel)]="underlineLinks"
                                (ngModelChange)="underlineLinksChange()"
                            ></agpr-checkbox>
                        </div>
                    </agpr-panel>
                }

                <agpr-panel
                    [id]="id + '_snippetPanel'"
                    [header]="'Mention.customization.snippet'"
                    [headerIcon]="'fa-regular fa-duotone fa-align-left'"
                    [styleClass]="'agpr-mentionCustomization-panel agpr-mentionCustomization-panelBase agpr-mentionCustomization-panel--snippet'"
                    [marginTop]="0"
                    [noBorder]="true"
                    [contentPadding]="false"
                    [paddingBottom]="0"
                    [(collapsed)]="sectionCollapsed.snippet"
                >
                    <div class="agpr-mentionCustomization-panelContent">
                        <div
                            role="group"
                            class="agpr-mentionCustomization-snippet"
                            [attr.aria-label]="'Mention.customization.snippet' | localize"
                        >
                            <agpr-checkbox
                                class="agpr-mentionCustomization-snippetCheckbox"
                                [id]="id + '_includeSnippet'"
                                label="Mention.customization.showSnippet"
                                [binary]="true"
                                [(ngModel)]="isMentionContentIncluded"
                                (ngModelChange)="toggleMentionContentIncluded()"
                            ></agpr-checkbox>
                            @if (isMentionContentIncluded) {
                                <div
                                    role="radiogroup"
                                    class="agpr-mentionCustomization-indent"
                                    [attr.aria-label]="'Mention.customization.snippetOptions' | localize"
                                >
                                    <agpr-radio
                                        class="agpr-mentionCustomization-contentLead"
                                        [id]="id + '_includeLead'"
                                        label="Mention.customization.lead"
                                        hiddenLabel="Mention.customization.lead"
                                        [value]="mentionContentCustomization.lead"
                                        name="snippet_options"
                                        [disabled]="!isMentionContentIncluded"
                                        [(ngModel)]="selectedMentionContentRadioButton"
                                        (ngModelChange)="mentionSnippetChange($event)"
                                    ></agpr-radio>
                                    @if (selectedMentionContentRadioButton == mentionContentCustomization.lead) {
                                        <div class="agpr-mentionCustomization-indent">
                                            <agpr-checkbox
                                                class="agpr-mentionCustomization-contentFullText"
                                                [id]="id + '_includeFullText'"
                                                label="Mention.customization.fullText"
                                                [disabled]="!isMentionContentIncluded"
                                                [binary]="true"
                                                [(ngModel)]="isFullTextSelected"
                                                (ngModelChange)="mentionSnippetChange(mentionContentCustomization.fullText)"
                                            ></agpr-checkbox>
                                        </div>
                                    }
                                    <agpr-radio
                                        class="agpr-mentionCustomization-contentSummary"
                                        [id]="id + '.includeSummary'"
                                        label="Mention.customization.contextualSnippet"
                                        hiddenLabel="Mention.customization.contextualSnippet"
                                        [value]="mentionContentCustomization.summary"
                                        name="snippet_options"
                                        [disabled]="!isMentionContentIncluded"
                                        [(ngModel)]="selectedMentionContentRadioButton"
                                        (ngModelChange)="mentionSnippetChange($event)"
                                    ></agpr-radio>
                                    @if (isMentionContentIncluded) {
                                        <agpr-briefing-text-style-field
                                            class="agpr-mentionCustomization-snippetFont"
                                            [id]="id + '.snippetFont'"
                                            [field]="snippetFontField"
                                            [value]="snippetFont"
                                            [hidePadding]="true"
                                            [smallLabel]="true"
                                            [subheadingSpacing]="'compact'"
                                            (changes)="setStyle($event, snippetFontField.property)"
                                        ></agpr-briefing-text-style-field>
                                    }
                                    <agpr-checkbox
                                        class="agpr-mentionCustomization-highlightKeywords"
                                        [id]="id + '_highlightKeywords'"
                                        label="Mention.customization.highlightKeywords"
                                        [binary]="true"
                                        [disabled]="!isMentionContentIncluded"
                                        infoCircletooltip="Mention.customization.highlightKeywords.tooltip"
                                        [(ngModel)]="highlightKeywords"
                                        (ngModelChange)="toggleHighlightKeywords()"
                                    ></agpr-checkbox>
                                </div>
                            }
                        </div>
                    </div>
                </agpr-panel>

                @if (showInsightsSection) {
                    <agpr-panel
                        [id]="id + '_insightsPanel'"
                        [header]="'Mention.customization.insights'"
                        [headerIcon]="'fa-regular fa-duotone fa-lightbulb'"
                        [styleClass]="'agpr-mentionCustomization-panel agpr-mentionCustomization-panelBase agpr-mentionCustomization-panel--insights'"
                        [marginTop]="0"
                        [noBorder]="true"
                        [contentPadding]="false"
                        [paddingBottom]="0"
                        [(collapsed)]="sectionCollapsed.insights"
                    >
                        <div class="agpr-mentionCustomization-panelContent">
                            <div
                                role="group"
                                [attr.aria-label]="'Mention.customization.insight' | localize"
                            >
                                <agpr-checkbox
                                    class="agpr-mentionCustomization-insightsCheckbox"
                                    [id]="id + '_includeInsight'"
                                    label="Mention.customization.showInsights"
                                    [binary]="true"
                                    [(ngModel)]="showInsights"
                                    (ngModelChange)="showInsightChange()"
                                ></agpr-checkbox>
                                @if (showInsights) {
                                    <div
                                        role="radiogroup"
                                        class="agpr-mentionCustomization-insights-radioButtons agpr-mentionCustomization-indent"
                                        [attr.aria-label]="'Mention.customization.insightOptions' | localize"
                                    >
                                        <agpr-checkbox
                                            class="agpr-mentionCustomization-insightsCheckbox"
                                            [id]="id + '_insightsNameDisplay'"
                                            label="Mention.customization.insightsNameDisplay"
                                            [binary]="true"
                                            [bottomMargin]="true"
                                            [(ngModel)]="displayInsightsName"
                                            (ngModelChange)="insightsNameDisplayChange()"
                                        ></agpr-checkbox>
                                        @if (displayInsightsName) {
                                            <div class="agpr-mentionCustomization-indent">
                                                <agpr-radio
                                                    [id]="id + '_insightsName'"
                                                    label="Mention.customization.insightsName"
                                                    hiddenLabel="Mention.customization.insightsName"
                                                    [value]="insightsDisplayNameEnum.insightsName"
                                                    name="insight_options"
                                                    [(ngModel)]="insightsNameDisplay"
                                                    (ngModelChange)="insightsNameChange()"
                                                ></agpr-radio>
                                                <div class="agpr-mentionCustomization-optionalInput">
                                                    <agpr-radio
                                                        [id]="id + '_insightCustom'"
                                                        label="Mention.customization.custom"
                                                        hiddenLabel="Mention.customization.custom"
                                                        [value]="insightsDisplayNameEnum.custom"
                                                        name="insight_options"
                                                        [(ngModel)]="insightsNameDisplay"
                                                        (ngModelChange)="insightsNameChange()"
                                                    ></agpr-radio>
                                                    @if (insightsNameDisplay == insightsDisplayNameEnum.custom) {
                                                        <div class="agpr-mentionCustomization-indent">
                                                            <agpr-text-input
                                                                [id]="id + '_customInsightsName'"
                                                                [(ngModel)]="customInsightsName"
                                                                (ngModelChange)="customInsightsNameChange()"
                                                            ></agpr-text-input>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        <agpr-briefing-text-style-field
                                            [layoutVariant]="'insights'"
                                            [id]="id + '.insightsFont'"
                                            [field]="insightsFontField"
                                            [value]="insightsFont"
                                            [hidePadding]="true"
                                            [subheadingSpacing]="'none'"
                                            (changes)="setStyle($event, insightsFontField.property)"
                                        ></agpr-briefing-text-style-field>
                                    </div>
                                }
                            </div>
                        </div>
                    </agpr-panel>
                }

                <agpr-panel
                    [id]="id + '_metadataPanel'"
                    [header]="'Mention.customization.metadata'"
                    [headerIcon]="'fa-regular fa-duotone fa-square-info'"
                    [styleClass]="'agpr-mentionCustomization-panel agpr-mentionCustomization-panelBase agpr-mentionCustomization-panel--metadata'"
                    [marginTop]="0"
                    [noBorder]="true"
                    [contentPadding]="false"
                    [paddingBottom]="0"
                    [(collapsed)]="sectionCollapsed.metadata"
                >
                    <div class="agpr-mentionCustomization-panelContent">
                        <div
                            role="group"
                            [attr.aria-label]="'Mention.customization.metadata' | localize"
                        >
                            <div class="agpr-mentionCustomization-metadata">
                                <agpr-briefing-text-style-field
                                    class="agpr-mentionCustomization-metadataFont"
                                    [id]="id + '_metadataFont'"
                                    [field]="metadataFontField"
                                    [value]="metadataFont"
                                    [hidePadding]="true"
                                    (changes)="setStyle($event, metadataFontField.property)"
                                ></agpr-briefing-text-style-field>

                                <div
                                    class="agpr-mentionCustomization-metadataToggle"
                                    [ngClass]="{ 'agpr-mentionCustomization-metadataToggle--expanded': metadataListExpanded }"
                                    role="button"
                                    tabindex="0"
                                    (click)="toggleMetadataList()"
                                    (keydown)="metadataToggleKeydown($event)"
                                    [attr.aria-expanded]="metadataListExpanded"
                                >
                                    <span class="agpr-mentionCustomization-metadataToggleLabel">
                                        {{ 'Mention.customization.metadataAdded' | localize: { count: metadataSelectedCount } }}
                                    </span>
                                    <span
                                        class="agpr-mentionCustomization-metadataToggleIcon agpr-expandToggle"
                                        [ngClass]="metadataListExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                                        aria-hidden="true"
                                    ></span>
                                </div>

                                @if (metadataListExpanded) {
                                    <div class="agpr-mentionCustomization-metadataList">
                                        @for (option of checkboxOptions; track option.key) {
                                            <div class="agpr-mentionCustomization-metadataOption">
                                                <agpr-checkbox
                                                    [id]="id + '_metadata_' + option.key"
                                                    [(ngModel)]="selectedMetadataTypes"
                                                    [value]="option.key"
                                                    [label]="option.label"
                                                    [infoCircleTooltip]="option.tooltip"
                                                    [disabled]="option.disabled"
                                                    name="metadataOptions"
                                                    (ngModelChange)="mentionMetadataChange($event)"
                                                >
                                                    @if (option.key === mentionMetadataTypesEnum.domainAuthority) {
                                                        <img
                                                            class="agpr-mentionCustomization-metadataMozLogo"
                                                            [src]="'assets/images/moz-logo.svg'"
                                                            [alt]="'Common.domainAuthority.moz' | localize"
                                                        />
                                                    }
                                                </agpr-checkbox>
                                            </div>
                                        }

                                        <div class="agpr-mentionCustomization-optionalInput">
                                            <agpr-checkbox
                                                class="agpr-mentionCustomization-image"
                                                [id]="id + '_image'"
                                                label="Mention.customization.metadataType.image"
                                                [binary]="true"
                                                [ngModel]="showImageSelection"
                                                (ngModelChange)="toggleImageSelection($event)"
                                            ></agpr-checkbox>
                                            @if (showImageSelection) {
                                                <div class="agpr-mentionCustomization-indent">
                                                    <agpr-radio
                                                        [id]="id + '_image_thumbnail'"
                                                        [value]="imageSizeEnum.thumbnail"
                                                        label="Mention.customization.metadataType.image.thumbnail"
                                                        [(ngModel)]="imageSize"
                                                        (onClick)="imageSizeChanged(imageSizeEnum.thumbnail)"
                                                    ></agpr-radio>
                                                    <agpr-radio
                                                        [id]="id + '_image_fullWidth'"
                                                        [value]="imageSizeEnum.fullWidth"
                                                        label="Mention.customization.metadataType.image.fullWidth"
                                                        [(ngModel)]="imageSize"
                                                        (onClick)="imageSizeChanged(imageSizeEnum.fullWidth)"
                                                    ></agpr-radio>
                                                </div>
                                            }
                                        </div>

                                        @if (showEngagement && allowEngagementMetadata) {
                                            <div class="agpr-mentionCustomization-optionalInput">
                                                <agpr-checkbox
                                                    [id]="id + '_engagement'"
                                                    label="Mention.customization.metadataType.engagements"
                                                    infoCircleTooltip="Mention.customization.metadataType.engagements.tooltip"
                                                    [binary]="true"
                                                    [(ngModel)]="engagement"
                                                    (ngModelChange)="toggleEngagement($event)"
                                                ></agpr-checkbox>
                                            </div>
                                        }

                                        <div class="agpr-mentionCustomization-optionalInput">
                                            <agpr-checkbox
                                                class="agpr-mentionCustomization-AVE"
                                                [id]="id + '_showAVE'"
                                                label="Mention.customization.metadataType.adValueEquivalency"
                                                [binary]="true"
                                                [ngModel]="showCurrencySelection"
                                                (ngModelChange)="toggleAVE($event)"
                                            ></agpr-checkbox>
                                            @if (showCurrencySelection) {
                                                <div class="agpr-mentionCustomization-indent">
                                                    <agpr-autocomplete
                                                        id="id + '_currencyAutocompelete'"
                                                        [suggestions]="suggestions$"
                                                        labelField="label"
                                                        [dropdown]="true"
                                                        [clearOnBlur]="false"
                                                        [minLength]="1"
                                                        [ariaLabel]="'Mention.customization.metadataType.adValueEquivalency'"
                                                        [(ngModel)]="selectedUserCurrency"
                                                        (itemSelected)="currencyChanged($event)"
                                                    ></agpr-autocomplete>
                                                </div>
                                            }
                                        </div>

                                        <div class="agpr-mentionCustomization-publishedDateInput">
                                            <agpr-checkbox
                                                [id]="id + '_showPublishedDateField'"
                                                label="Mention.customization.metadataType.publishedDate"
                                                [binary]="true"
                                                [value]="mentionMetadataTypesEnum.publishedDate"
                                                [ngModel]="showPublishedDateMetadata"
                                                (ngModelChange)="showPublishedDateMetadataChanged($event)"
                                            ></agpr-checkbox>
                                            @if (showPublishedDateMetadata) {
                                                <div class="agpr-mentionCustomization-indent agpr-mentionCustomization-metadataDateRow">
                                                    <div class="agpr-mentionCustomization-metadataDateRowItem">
                                                        <agpr-dropdown
                                                            [label]="'Mention.customization.dateFormat'"
                                                            [options]="dateFormatOptions"
                                                            [ngModel]="selectedDateFormat"
                                                            (ngModelChange)="dateFormatChanged($event)"
                                                        ></agpr-dropdown>
                                                    </div>
                                                    <div class="agpr-mentionCustomization-metadataDateRowItem">
                                                        <agpr-timezone-picker
                                                            class="agpr-mentionCustomization-metadataTimezone"
                                                            [label]="'Mention.customization.timezone'"
                                                            [ngModel]="timezone"
                                                            (ngModelChange)="timezoneChanged($event)"
                                                        ></agpr-timezone-picker>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </agpr-panel>

                @if (showMentionInsightsLinkSection) {
                    <agpr-panel
                        [id]="id + '_mentionInsightsLinkPanel'"
                        [header]="'Mention.customization.mentionInsightLink'"
                        [headerIcon]="'fa-kit-duotone fa-agpr-insights'"
                        [styleClass]="'agpr-mentionCustomization-panel agpr-mentionCustomization-panelBase agpr-mentionCustomization-panel--mentionInsightsLink'"
                        [marginTop]="0"
                        [noBorder]="true"
                        [contentPadding]="false"
                        [paddingBottom]="0"
                        [(collapsed)]="sectionCollapsed.mentionInsightsLink"
                    >
                        <div class="agpr-mentionCustomization-panelContent">
                            <div class="agpr-mentionCustomization-mentionInsights">
                                @if (hasMentionInsightsEnabled) {
                                    <agpr-text-input
                                        class="agpr-mentionCustomization-mentionInsightLinkLabel"
                                        [id]="id + '_mentionInsightLinkLabel'"
                                        ariaLabel="Mention.customization.mentionInsightLinkPlaceholder"
                                        [maxlength]="64"
                                        placeholder="Mention.customization.mentionInsightLinkPlaceholder"
                                        [(ngModel)]="mentionInsightsLinkLabel"
                                        (ngModelChange)="setMentionInsightsLinkLabel()"
                                    ></agpr-text-input>

                                    <agpr-briefing-text-style-field
                                        class="agpr-mentionCustomization-mentionInsightLinkFont"
                                        [id]="id + '_mentionInsightLinkFont'"
                                        [field]="mentionInsightsLinkFontField"
                                        [value]="mentionInsightsLinkFont"
                                        [hidePadding]="true"
                                        [subheadingSpacing]="'none'"
                                        (changes)="setStyle($event, mentionInsightsLinkFontField.property)"
                                    ></agpr-briefing-text-style-field>
                                } @else {
                                    <agpr-briefing-insight-upsell-card></agpr-briefing-insight-upsell-card>
                                }
                            </div>
                        </div>
                    </agpr-panel>
                }

                <agpr-panel
                    [id]="id + '_additionalSettingsPanel'"
                    [header]="'Mention.customization.additional'"
                    [headerIcon]="'fa-regular fa-duotone fa-gear'"
                    [styleClass]="'agpr-mentionCustomization-panel agpr-mentionCustomization-panelBase agpr-mentionCustomization-panel--additional'"
                    [marginTop]="0"
                    [noBorder]="true"
                    [contentPadding]="false"
                    [paddingBottom]="0"
                    [(collapsed)]="sectionCollapsed.additional"
                >
                    <div class="agpr-mentionCustomization-panelContent">
                        <div role="group" [attr.aria-label]="'Mention.customization.additional' | localize">
                            <!-- Notes -->
                            <div class="agpr-mentionCustomization-note">
                                @if (includeNotes) {
                                    <agpr-checkbox
                                        [id]="id + '_includeMentionNotes'"
                                        label="Mention.customization.notes"
                                        [binary]="true"
                                        [(ngModel)]="notes"
                                        (ngModelChange)="toggleNotes()"
                                    ></agpr-checkbox>
                                }
                                @if (notes) {
                                    <div class="agpr-mentionCustomization-indent">
                                        <div class="agpr-mentionCustomization-optionalInput">
                                            <agpr-checkbox
                                                [id]="id + '_displayMentionNotesLabel'"
                                                label="Mention.customization.notesLabel"
                                                [binary]="true"
                                                [(ngModel)]="displayNotesLabel"
                                                (ngModelChange)="toggleDisplayNotes()"
                                            ></agpr-checkbox>
                                            @if (displayNotesLabel) {
                                                <div class="agpr-mentionCustomization-indent">
                                                    <agpr-text-input
                                                        class="agpr-mentionCustomization-notesLabel"
                                                        [id]="id + '.mentionNotesLabel'"
                                                        ariaLabel="Mention.customization.notesLabelPlaceholder"
                                                        [maxlength]="64"
                                                        [(ngModel)]="notesLabel"
                                                        (ngModelChange)="setNotesLabel()"
                                                        [placeholder]="'Mention.customization.notesLabelPlaceholder' | localize"
                                                        [bottomMargin]="false"
                                                    ></agpr-text-input>
                                                </div>
                                            }
                                        </div>
                                        <agpr-briefing-text-style-field
                                            class="agpr-mentionCustomization-notesFont"
                                            [id]="id + '_notesFont'"
                                            [field]="notesFontField"
                                            [value]="notesFont"
                                            [hidePadding]="true"
                                            (changes)="setStyle($event, notesFontField.property)"
                                        ></agpr-briefing-text-style-field>
                                    </div>
                                }
                            </div>
                            <div class="agpr-mentionCustomization-backToTopLinksContainer">
                                <agpr-checkbox
                                    [id]="id + '_backToTopLinksLabel'"
                                    label="Mention.customization.backToTopLinksLabel"
                                    [binary]="true"
                                    [(ngModel)]="includeBackToTopLinks"
                                    (ngModelChange)="toggleIncludeBackToTopLinks()"
                                ></agpr-checkbox>
                                @if (includeBackToTopLinks) {
                                    <div class="agpr-mentionCustomization-indent">
                                        <agpr-text-input
                                            [id]="id + '.mentionIncludeBackToTopLinksLabel'"
                                            [maxlength]="64"
                                            label="Mention.customization.backToTopLinksTextLabel"
                                            placeholder="Mention.customization.backToTopLinksLabelPlaceholder"
                                            styleClass="agpr-mentionCustomization-backToTopLinksTextInput"
                                            [(ngModel)]="backToTopLinksLabel"
                                            (ngModelChange)="setBackToTopLinksLabel()"
                                        ></agpr-text-input>
                                        <agpr-briefing-text-style-field
                                            [layoutVariant]="'backToTopLinks'"
                                            [id]="id + '.notesFont'"
                                            [field]="backToTopLinksFontField"
                                            [value]="backToTopLinksFont"
                                            [hidePadding]="true"
                                            [subheadingSpacing]="'none'"
                                            (changes)="setStyle($event, backToTopLinksFontField.property)"
                                        ></agpr-briefing-text-style-field>
                                    </div>
                                }
                            </div>
                            @if (showConcisePlayer) {
                                <div class="agpr-mentionCustomization-concisePlayerOption">
                                    <agpr-checkbox
                                        [id]="id + '_conciseBroadcastClipsLabel'"
                                        label="Mention.customization.conciseBroadcastClipsLabel"
                                        infoCircleTooltip="Mention.customization.conciseBroadcastClipsInfo"
                                        [binary]="true"
                                        [(ngModel)]="enforceConcisePlayer"
                                        (ngModelChange)="toggleEnforceConcisePlayer()"
                                    ></agpr-checkbox>
                                </div>
                            }
                        </div>
                    </div>
                </agpr-panel>

                <agpr-panel
                    [id]="id + '_paddingPanel'"
                    [header]="'PageBuilder.formField.padding'"
                    [headerIcon]="'fa-regular fa-duotone fa-distribute-spacing-horizontal'"
                    [styleClass]="'agpr-mentionCustomization-panel agpr-mentionCustomization-panelBase agpr-mentionCustomization-panel--padding'"
                    [marginTop]="0"
                    [noBorder]="true"
                    [contentPadding]="false"
                    [paddingBottom]="0"
                    [(collapsed)]="sectionCollapsed.padding"
                >
                    <div class="agpr-mentionCustomization-panelContent">
                        <div class="agpr-mentionCustomization-padding">
                            <agpr-block-padding
                                [id]="id + '_padding'"
                                [verticalOnly]="field.allowExpertMode"
                                [padding]="value.padding"
                                [showLabel]="false"
                                (paddingChanged)="setStyle($event, 'padding')"
                            ></agpr-block-padding>
                        </div>
                    </div>
                </agpr-panel>
            </div>
        }

        @if (value.template && !internalUser) {
            <agpr-message
                [severity]="messageSeverityEnum.info"
            >
                {{ 'PageBuilder.styles.expertStyleAppliedPreMessage' | localize }}
                <span style="font-weight:bold">
                {{ 'Briefings.blockType.mention' | localize}}
            </span>
                {{ 'PageBuilder.styles.expertStyleAppliedPostMessage' | localize }}
            </agpr-message>
        }
    </div>
</div>
